import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Link from 'components/ui/Link/Link'

import s from './Logo.scss'

import darkLogo, { ReactComponent as DarkLogoSVG } from './images/black.svg'
import lightLogo, { ReactComponent as LightLogoSVG } from './images/white.svg'


const Logo = ({ className, id, light, dark, to, redirect, style, inlineSvg = false }) => {
  let LogoSVG
  let src

  if (light) {
    src     = lightLogo
    LogoSVG = LightLogoSVG
  }
  else if (dark) {
    src     = darkLogo
    LogoSVG = DarkLogoSVG
  }
  else {
    throw new Error('Missed light or dark property in Logo component')
  }

  if (to || redirect) {
    return (
      <Link className={cx(s.logoLink, className, inlineSvg && s.svgLogoLink)} id={id} to={to} toOLD={redirect} style={style}>
        {
          inlineSvg ? (
            <LogoSVG className={s.svgLogo} />
          ) : (
            <img className={s.logoLinkImage} src={src} alt="Scentbird" />
          )
        }
      </Link>
    )
  }

  if (inlineSvg) {
    return (
      <LogoSVG className={cx(s.svgLogo, className)} />
    )
  }

  return (
    <img className={className} id={id} src={src} alt="Scentbird" />
  )
}

Logo.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  light: PropTypes.bool,
  dark: PropTypes.bool,
  to: PropTypes.string,
  redirect: PropTypes.string,
  inlineSvg: PropTypes.bool,
}


export default Logo
